"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as v } from "../../hooks.js";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: o, size: c = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = i(), t = o !== null && o !== void 0 ? o : l ? r.colors.inverse : r.colors.neutralHigh, { skinName: h } = v();
    return h.match(/^blau/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M17.92 8.668c-.336-2.984-2.868-5.308-5.932-5.308-3.292 0-5.972 2.688-5.972 5.988H4.66C4.66 5.296 7.948 2 11.988 2s7.328 3.296 7.328 7.348v.68h-2.728c-.324 2.256-2.26 4-4.6 4-2.564 0-4.652-2.092-4.652-4.664S9.424 4.7 11.988 4.7c2.328 0 4.26 1.724 4.596 3.968zm-9.228.696c0 1.82 1.48 3.304 3.296 3.304a3.3 3.3 0 0 0 3.228-2.64h-3.228v-1.36h3.22a3.3 3.3 0 0 0-3.22-2.608 3.303 3.303 0 0 0-3.296 3.304M14.424 15.276l4.916.98a3.32 3.32 0 0 1 2.656 3.252v1.84H20.64v-1.844a1.96 1.96 0 0 0-1.568-1.916l-4.204-.84-2.956 2.964L9.7 16.756l-4.74.868a1.95 1.95 0 0 0-1.604 1.924v1.8H2v-1.796c0-1.608 1.14-2.98 2.716-3.264l5.568-1.02 1.776 2.376z"
        })
    })) : h.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M17.153 11.642H16.03a4.8 4.8 0 0 1-1.043 1.124c2.651.788 4.379 2.64 4.379 4.967v3.547c0 .396-.33.716-.738.716a.726.726 0 0 1-.738-.716v-3.547c0-2.288-2.478-3.951-5.893-3.951-1.719 0-3.257.424-4.337 1.188-1.019.72-1.555 1.68-1.555 2.767v3.547c0 .396-.33.716-.738.716a.726.726 0 0 1-.738-.716v-3.547c0-1.54.767-2.931 2.157-3.92.635-.447 1.39-.799 2.222-1.047-1.097-.852-1.802-2.163-1.802-3.627 0-2.56 2.148-4.643 4.787-4.643 2.64 0 4.788 2.083 4.788 4.643 0 .368-.046.728-.128 1.072h.499a.73.73 0 0 0 .738-.716v-.204c0-3.123-2.544-5.755-5.674-5.863a5.96 5.96 0 0 0-4.309 1.6C6.75 6.12 6.11 7.579 6.11 9.142c0 .397-.33.717-.738.717a.726.726 0 0 1-.738-.716c0-1.956.8-3.78 2.251-5.139 1.448-1.36 3.361-2.068 5.381-2a7.32 7.32 0 0 1 5.051 2.256 7.24 7.24 0 0 1 2.046 5.035v.204c0 1.183-.994 2.143-2.21 2.143m-5.155-5.714c-1.83 0-3.315 1.443-3.315 3.215s1.489 3.211 3.32 3.22c.787 0 1.509-.269 2.078-.717h-1.344a.726.726 0 0 1-.739-.716c0-.395.33-.715.739-.715h2.387a3.1 3.1 0 0 0 .19-1.072c0-1.776-1.485-3.215-3.316-3.215"
        })
    })) : h.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M17.153 11.642H16.03c-.284.428-.64.808-1.043 1.124 2.651.788 4.379 2.64 4.379 4.967v3.547c0 .396-.33.716-.738.716a.726.726 0 0 1-.738-.716v-3.547c0-2.288-2.478-3.951-5.893-3.951-1.719 0-3.257.424-4.337 1.188-1.019.72-1.555 1.68-1.555 2.767v3.547c0 .396-.33.716-.738.716a.726.726 0 0 1-.738-.716v-3.547c0-1.54.767-2.931 2.157-3.92.635-.447 1.39-.799 2.222-1.047-1.097-.852-1.802-2.163-1.802-3.627 0-2.56 2.148-4.643 4.787-4.643 2.64 0 4.788 2.083 4.788 4.643 0 .368-.046.728-.128 1.072h.499a.73.73 0 0 0 .738-.716v-.204c0-3.123-2.544-5.755-5.674-5.863a5.96 5.96 0 0 0-4.309 1.6C6.75 6.12 6.11 7.579 6.11 9.142c0 .397-.33.717-.738.717a.726.726 0 0 1-.738-.716c0-1.956.8-3.78 2.251-5.139 1.448-1.36 3.361-2.068 5.381-2a7.32 7.32 0 0 1 5.051 2.256 7.24 7.24 0 0 1 2.046 5.035v.204c0 1.183-.994 2.143-2.21 2.143m-5.155-5.714c-1.83 0-3.315 1.443-3.315 3.215s1.489 3.211 3.32 3.22c.787 0 1.509-.269 2.078-.717h-1.344a.726.726 0 0 1-.739-.716c0-.395.33-.715.739-.715h2.387a3.1 3.1 0 0 0 .19-1.072c0-1.776-1.485-3.215-3.316-3.215"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M16.035 10.86h.414c.56 0 1.011-.167 1.339-.492s.504-.796.504-1.364l.008-.544v-.008c0-2.073-.563-3.667-1.675-4.74-1.07-1.033-2.624-1.557-4.616-1.557-1.79 0-3.232.423-4.283 1.26-1.098.877-1.753 2.185-1.95 3.894a.563.563 0 0 0 .494.622.563.563 0 0 0 .621-.493c.16-1.403.675-2.462 1.535-3.146.846-.675 2.054-1.017 3.583-1.017 1.692 0 2.983.418 3.84 1.244.883.852 1.33 2.174 1.33 3.93l-.007.544V9c0 .182-.029.431-.171.571q-.169.168-.552.168h-.108q.07-.468.071-.997c0-2.837-1.565-4.4-4.4-4.4s-4.4 1.563-4.4 4.4 1.562 4.4 4.4 4.4c2.025 0 3.4-.795 4.023-2.282m-2.1 0h.839q-.14.216-.32.387c-.537.519-1.358.782-2.442.782s-1.905-.263-2.443-.782c-.557-.535-.837-1.375-.837-2.501s.283-1.966.837-2.501c.538-.519 1.359-.782 2.443-.782 1.087 0 1.907.26 2.442.782.558.535.838 1.375.838 2.501q0 .542-.087.994h-1.28c-.157-.233-.428-.367-.782-.367-.58 0-.938.359-.938.933q.001.427.247.678c.162.168.403.255.689.255s.532-.09.694-.255a1 1 0 0 0 .1-.123M3.538 21.85h16.933c.311 0 .56-.25.56-.56v-1.64c0-1.565-.49-2.904-1.42-3.87-1.01-1.05-2.512-1.605-4.339-1.605H8.737c-1.826 0-3.327.554-4.339 1.605-.93.966-1.42 2.305-1.42 3.87v1.64c0 .308.252.56.56.56m.56-1.12v-1.08c0-1.271.384-2.341 1.11-3.092.807-.837 1.994-1.263 3.532-1.263h6.532c1.538 0 2.726.426 3.533 1.263.722.751 1.106 1.821 1.106 3.093v1.078z"
        })
    }));
}, f = n;
export { f as default };
